import { Component, signal } from '@angular/core';
import { Aszf } from './aszf/aszf';
import { FullScreenModal } from './full-screen-modal/full-screen-modal';

@Component({
  selector: 'app-root',
  imports: [Aszf],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
   title = 'aszf-app';
}
